export default "data:application/wasm;base64,AGFzbQEAAAABBQFgAAF7AwIBAAoKAQgAQQD9D/1iCwAKBG5hbWUCAwEAAA=="